import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'TextList',
})(({ brandColors, spacing, breakpoints }, props) => ({
  textList: {
    padding: `${spacing(2)} 0`,
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: 'calc(100% - 24px)',
      margin: '0 12px',
      bottom: 0,
      borderBottom: darkOrLightStyle(props)(
        '1px solid rgba(255, 255, 255, 0.30)',
        '1px solid rgba(0, 0, 0, 0.20)'
      ),
      [breakpoints.up('sm')]: {
        width: 'calc(100% - 40px)',
        margin: '0 20px',
      },
      [breakpoints.up('lg')]: {
        width: 'calc(100% - 80px)',
        margin: '0 40px',
      },
    },
  },
  textListHeading: {
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
  textListBody: {
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
  },
}));

export default useStyles;
